import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps, useMediaQuery } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
export const TypingDots = () => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["(prefers-reduced-motion: reduce)"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [prefersReducedMotion] = useMediaQuery(t0);
  const animation1 = prefersReducedMotion ? undefined : `${keyframe_dot1} infinite 1s linear`;
  const animation2 = prefersReducedMotion ? undefined : `${keyframe_dot2} infinite 1s linear`;
  const animation3 = prefersReducedMotion ? undefined : `${keyframe_dot3} infinite 1s linear`;
  let t1;
  if ($[1] !== animation1) {
    t1 = <Box {...styles.dot1 as BoxProps} animation={animation1} />;
    $[1] = animation1;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== animation2) {
    t2 = <Box {...styles.dot2 as BoxProps} animation={animation2} />;
    $[3] = animation2;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== animation3) {
    t3 = <Box {...styles.dot3 as BoxProps} animation={animation3} />;
    $[5] = animation3;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <Box>{t1}{t2}{t3}</Box>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
const keyframe_dot1 = keyframes`
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1, 1.5);
  }
  50% {
    transform: scale(1, 0.67);
  }
  75% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 1);
  }
`;
const keyframe_dot2 = keyframes`
 0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1, 1.5);
  }
  75% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 1);
  }
`;
const keyframe_dot3 = keyframes`
 0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1, 0.67);
  }
  75% {
    transform: scale(1, 1.5);
  }
  100% {
    transform: scale(1, 1);
  }
`;
const styles = {
  dot1: {
    position: 'relative',
    width: '10px',
    height: '10px',
    borderRadius: '5px',
    backgroundColor: '#FFF',
    color: '#FFF',
    display: ' inline-block',
    margin: '0 2px'
  },
  dot2: {
    width: '10px',
    height: '10px',
    borderRadius: '5px',
    backgroundColor: '#FFF',
    color: '#FFF',
    display: 'inline-block',
    margin: '0 2px'
  },
  dot3: {
    width: '10px',
    height: '10px',
    borderRadius: '5px',
    backgroundColor: '#FFF',
    display: 'inline-block',
    margin: '0 2px'
  }
};